import axios from 'axios';
import {
  ADD_EXERCISE,
  EDIT_EXERCISE, FETCH_CORPORATE_EXERCISES,
  FETCH_EQUIPMENT,
  FETCH_EXERCISE_CATS, FETCH_EXERCISE_VIDEOS, FETCH_TRAINER_EXERCISES,
  RESET_EXERCISES_LISTING,
  RESET_EXERCISE_FILTER,
  SET_EXERCISE_SEARCH_TERM,
  SET_EXCERCISE_FILTER,
  UPDATE_EXERCISES_FAVOURITE,
  FETCH_FAVOURITE_EXERCISES
} from '../actionTypes';
import { showAlert } from './alert';
import { hideLoader, showLoader } from './loader';
import { checkState } from './../../helpers'

const SERVICE = `exercises`;

export const fetchMyExercises = query => dispatch => {
	dispatch(showLoader());
	return new Promise(function (resolve, reject) {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(SERVICE, {
				params: query,
			})
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: FETCH_TRAINER_EXERCISES,
					payload: res.data,
				});
				return resolve(res['data']);
			});
	});
};

export const resetExercisesListing = () => dispatch => {
	dispatch({
		type: RESET_EXERCISES_LISTING,
	});
};

export const resetExerciseFilter = () => dispatch => {
	dispatch({
		type: RESET_EXERCISE_FILTER,
	});
};

export const setExerciseFilter = (filter) => dispatch => {
	dispatch({
		type: SET_EXCERCISE_FILTER,
		payload: filter,
	});
};

export const setExerciseSearchTerm = (term) => dispatch => {
	dispatch({
		type: SET_EXERCISE_SEARCH_TERM,
		payload: term,
	});
};

export const fetchMoreExercise = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('exercises', {
			params: query,
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			dispatch(hideLoader());
			const data = values[0].data;
			if(query.creatorType === 'brand') {
				dispatch({
					type: FETCH_CORPORATE_EXERCISES,
					payload: Object.values(data),
				});
			} else {
				if(query.isMyfavourite) {
					dispatch({
						type: FETCH_FAVOURITE_EXERCISES,
						payload: Object.values(data),
					});
				} else {
					dispatch({
						type: FETCH_TRAINER_EXERCISES,
						payload: Object.values(data),
					});
				}
			}
		});
	});
};

export const toggleExerciseFavourite = (param) => dispatch => {
	dispatch(showLoader());
	const { exerciseId, isFavourite } = param;
	return new Promise(async (response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		await axios
			.post(`${SERVICE}/like/${exerciseId}`, {
				liked: isFavourite,
			})
			.then(res => {
				dispatch(hideLoader());
				dispatch({
					type: UPDATE_EXERCISES_FAVOURITE,
					payload: {
						...param
					},
				});
				response(res.data);
			})
			.catch(err => {
				dispatch(hideLoader());
				return dispatch(showAlert(err.message));
			});
	});
};


export const fetchCorporateExercises = () => dispatch => {
	dispatch(showLoader());
	return new Promise(function (resolve, reject) {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios.get(SERVICE).then(res => {
			dispatch(hideLoader());
			dispatch({
				type: FETCH_CORPORATE_EXERCISES,
				payload: res.data,
			});
			return resolve(res['data']);
		});
	});
};

export const editExercise = (editId, exercise, user) => dispatch => {
	if (!editId) {
		console.error('exercise does not have id');
		return false;
	}
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.patch(`${SERVICE}/${editId}`, exercise)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert(exercise.isTranscoding ? 'Exercise is processing. Once it processed then we will inform you.' : 'Exercise updated successfully.'));
			return dispatch({
				type: EDIT_EXERCISE,
				payload: {
					[res.data._id]: res.data,
				},
				user: user,
			});
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
			console.warn(error);
		});
};

export const addExercise = (exerciseData, user) => (dispatch, getState) => {
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	return axios
		.post(SERVICE, exerciseData)
		.then(res => {
			dispatch(hideLoader());
			if (res.data._id) {
				dispatch(showAlert(exerciseData.isTranscoding ? 'Exercise is processing. Once it processed then we will inform you.' : 'Exercise has been saved successfully. Please go to library for edit it.'));
				dispatch({
					type: ADD_EXERCISE,
					payload: {
						[res.data._id]: res.data,
					},
					user: user,
				});
			} else {
				console.error('Failed to add exericse.', exerciseData);
			}
		})
		.catch(function (error) {
			dispatch(hideLoader());
			console.warn(error);
			dispatch(showAlert('Failed to add exericse.', true));
		});
};

export const fetchFormValues = userId => (dispatch, getState) => {
	let promises = [];
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	const state = getState();
	const { equipment, exerciseCats } = state;
	promises = checkState(promises, 'categories',  {
		type: 'equipment'
	}, equipment)
	// promises.push(
	// 	axios.get('files', {
	// 		params: {
	// 			category: 'exercise',
	// 			userId: userId,
	// 		},
	// 	})
	// );
	promises = checkState(promises, 'categories', {
		type: 'body-part',
	}, exerciseCats)
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const equipmentData = values[0].data;
			//const fileData = values[1].data;
			const corporateCatData = values[1].data;
			dispatch({
				type: FETCH_EQUIPMENT,
				payload: equipmentData,
			});
			// dispatch({
			// 	type: FETCH_EXERCISE_VIDEOS,
			// 	payload: fileData,
			// });
			dispatch({
				type: FETCH_EXERCISE_CATS,
				payload: {
					...corporateCatData,
				},
			});
			dispatch(hideLoader());
			respond();
		});
	});
};



// WEBPACK FOOTER //
// ./src/store/actions/exercises.js